import { isEmpty } from 'lodash';
import { RETAILER_ORDERS_CLOSE_MODAL, RETAILER_ORDERS_MODAL, RETAILER_ORDERS_ORDER } from '../constants/retailerOrders';

const initialState = {
  order: {
    loading: false,
    current: null,
  },
  modal: {
    open: false,
  },
};

const retailerOrders = (state = initialState, action) => {
  switch (action.type) {
    case RETAILER_ORDERS_ORDER:
      return {
        ...state,
        order: {
          ...state.order,
          ...action.payload,
        },
        modal: {
          open: !isEmpty(action.payload),
        },
      };

    case RETAILER_ORDERS_MODAL:
      return {
        ...state,
        modal: {
          ...state.modal,
          ...action.payload,
        },
      };

    case RETAILER_ORDERS_CLOSE_MODAL:
      return initialState;

    default:
      break;
  }

  return state;
};

export default retailerOrders;
